module.exports = __webpack_public_path__ + "img/token-red.e74ba540.svg";